import React from "react";

const CATEGORY_OPTIONS = [
    { value: "drone", label: "Drone sinematografisi" },
    { value: "interior", label: "İç mekân mimari" },
    { value: "exterior", label: "Dış mekân mimari" },
    { value: "landscape", label: "Peyzaj tasarım" },
];

const CATEGORY_HELPERS = {
    drone: {
        headline: "Lansman reel, masterplan uçuşu ve set süpervizyonu gibi alt paketleri burada listeleyin.",
        focusLabel: "Drone alt paketleri",
        focusPlaceholder: "Örn. Lansman reel – 60 sn hero video, storyboard + shot log",
    },
    interior: {
        headline: "Hospitality, örnek daire ve kurumsal çalışma alanları gibi alt başlıkları ekleyin.",
        focusLabel: "İç mekân alt paketleri",
        focusPlaceholder: "Örn. Hospitality lobby – gün/gece lookdev + VR pano",
    },
    exterior: {
        headline: "Karma kullanım, cephe yenileme veya kıyı projeleri gibi senaryoları girin.",
        focusLabel: "Dış mekân odak alanları",
        focusPlaceholder: "Örn. Cephe yenileme – mevcut vs. yeni karşılaştırmalı hero render",
    },
    landscape: {
        headline: "Okul kampüsü, hastane peyzajı veya villa bahçesi gibi segmentleri detaylandırın.",
        focusLabel: "Peyzaj segmentleri",
        focusPlaceholder: "Örn. Okul kampüsü – güvenli rota, aktivite avlusu, SUD çözümü",
    },
};

export default function ServiceEditor({
    draft,
    onChange,
    onSave,
    onReset,
    onDelete,
    onDuplicate,
    saving,
    hasChanges,
    supabaseEnabled,
}) {
    if (!draft) {
        return (
            <aside className="package-editor service-editor">
                <div className="package-editor__empty">Soldaki listeden bir hizmet seçin veya yeni bir tane ekleyin.</div>
            </aside>
        );
    }

    const categoryLabel = CATEGORY_OPTIONS.find((option) => option.value === draft.category)?.label;
    const categoryHelper = draft.category ? CATEGORY_HELPERS[draft.category] : null;

    const handleFieldChange = (field, value) => {
        onChange({ ...draft, [field]: value });
    };

    const handleListChange = (field, index, value) => {
        const next = [...(draft[field] ?? [])];
        next[index] = value;
        onChange({ ...draft, [field]: next });
    };

    const addListItem = (field) => {
        onChange({ ...draft, [field]: [...(draft[field] ?? []), ""] });
    };

    const removeListItem = (field, index) => {
        const next = (draft[field] ?? []).filter((_, idx) => idx !== index);
        onChange({ ...draft, [field]: next });
    };

    const handleFaqChange = (index, key, value) => {
        const next = [...(draft.faq ?? [])];
        next[index] = { ...next[index], [key]: value };
        onChange({ ...draft, faq: next });
    };

    const addFaq = () => {
        onChange({ ...draft, faq: [...(draft.faq ?? []), { question: "", answer: "" }] });
    };

    const removeFaq = (index) => {
        const next = (draft.faq ?? []).filter((_, idx) => idx !== index);
        onChange({ ...draft, faq: next });
    };

    return (
        <aside className="package-editor service-editor" aria-label="Hizmet düzenleyici">
            <header className="package-editor__header">
                <div>
                    <span className="package-editor__badge">{categoryLabel || draft.cardTitle || "Hizmet"}</span>
                    <h3 className="package-editor__title">{draft.title || "Yeni hizmet"}</h3>
                </div>
                <div className="package-editor__status">
                    <label className="package-editor__checkbox">
                        <input
                            type="checkbox"
                            checked={draft.published !== false}
                            onChange={() => handleFieldChange("published", !draft.published)}
                        />
                        Yayında olsun
                    </label>
                    {!supabaseEnabled && (
                        <p className="package-editor__hint">Supabase olmadan yayın durumu sadece bu oturumda tutulur.</p>
                    )}
                </div>
            </header>

            <section className="package-editor__preview">
                <div className="package-preview-card">
                    <span className="package-preview-card__badge">{categoryLabel || draft.cardTitle || "HİZMET"}</span>
                    <h4 className="package-preview-card__title">{draft.title || "Hizmet Başlığı"}</h4>
                    <p className="package-preview-card__summary">{draft.cardSummary || draft.intro || "Hizmet kartı özet metni"}</p>
                </div>
            </section>

            <div className="package-editor__grid">
                <fieldset className="package-editor__fieldset">
                    <legend>Kart</legend>
                    <label className="package-editor__label" htmlFor="service-card-title">Kart başlığı</label>
                    <input
                        id="service-card-title"
                        className="package-editor__input"
                        value={draft.cardTitle}
                        onChange={(event) => handleFieldChange("cardTitle", event.target.value)}
                        placeholder="ANİMASYON"
                    />
                    <label className="package-editor__label" htmlFor="service-card-summary">Kart özeti</label>
                    <textarea
                        id="service-card-summary"
                        className="package-editor__textarea"
                        value={draft.cardSummary}
                        onChange={(event) => handleFieldChange("cardSummary", event.target.value)}
                        placeholder="Kart açıklaması"
                    />
                </fieldset>

                <fieldset className="package-editor__fieldset">
                    <legend>Genel bilgiler</legend>
                    <label className="package-editor__label" htmlFor="service-category">Kategori</label>
                    <select
                        id="service-category"
                        className="package-editor__input"
                        value={draft.category || ""}
                        onChange={(event) => handleFieldChange("category", event.target.value)}
                    >
                        <option value="">Kategori seçin</option>
                        {CATEGORY_OPTIONS.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                    {categoryHelper && <p className="package-editor__hint">{categoryHelper.headline}</p>}
                    <label className="package-editor__label" htmlFor="service-slug">Anchor (slug)</label>
                    <input
                        id="service-slug"
                        className="package-editor__input"
                        value={draft.slug}
                        onChange={(event) => handleFieldChange("slug", event.target.value)}
                        placeholder="animasyon"
                    />
                    <label className="package-editor__label" htmlFor="service-title">Başlık</label>
                    <input
                        id="service-title"
                        className="package-editor__input"
                        value={draft.title}
                        onChange={(event) => handleFieldChange("title", event.target.value)}
                        placeholder="Animasyon & Walkthrough"
                    />
                    <label className="package-editor__label" htmlFor="service-intro">Kısa açıklama</label>
                    <textarea
                        id="service-intro"
                        className="package-editor__textarea"
                        value={draft.intro}
                        onChange={(event) => handleFieldChange("intro", event.target.value)}
                        placeholder="Hizmetin özet cümlesi"
                    />
                </fieldset>

                <fieldset className="package-editor__fieldset">
                    <legend>Öne çıkanlar</legend>
                    <div className="package-editor__chips">
                        {(draft.highlights ?? []).map((item, index) => (
                            <div key={`service-highlight-${index}`} className="package-editor__chip">
                                <input
                                    className="package-editor__input"
                                    value={item}
                                    onChange={(event) => handleListChange("highlights", index, event.target.value)}
                                    placeholder="Teslim süresi"
                                />
                                <button type="button" className="package-editor__chip-button" onClick={() => removeListItem("highlights", index)}>
                                    Sil
                                </button>
                            </div>
                        ))}
                        <button type="button" className="package-editor__chip-button" onClick={() => addListItem("highlights")}>
                            Öne çıkan madde ekle
                        </button>
                    </div>
                </fieldset>

                <fieldset className="package-editor__fieldset">
                    <legend>{categoryHelper?.focusLabel ?? "Odak alanları"}</legend>
                    <p className="package-editor__hint" style={{ marginTop: "-4px" }}>
                        {categoryHelper?.headline ?? "Alt paketleri veya segment başlıklarını burada sınıflandırın."}
                    </p>
                    <div className="package-editor__chips">
                        {(draft.focusPoints ?? []).map((item, index) => (
                            <div key={`service-focus-${index}`} className="package-editor__chip">
                                <textarea
                                    className="package-editor__textarea"
                                    value={item}
                                    onChange={(event) => handleListChange("focusPoints", index, event.target.value)}
                                    placeholder={categoryHelper?.focusPlaceholder ?? "Alt paket açıklaması"}
                                />
                                <button type="button" className="package-editor__chip-button" onClick={() => removeListItem("focusPoints", index)}>
                                    Sil
                                </button>
                            </div>
                        ))}
                        <button type="button" className="package-editor__chip-button" onClick={() => addListItem("focusPoints")}>
                            {categoryHelper?.focusLabel ? `${categoryHelper.focusLabel} ekle` : "Odak alanı ekle"}
                        </button>
                    </div>
                </fieldset>

                <fieldset className="package-editor__fieldset">
                    <legend>Teslim paketleri</legend>
                    <div className="package-editor__chips">
                        {(draft.deliverables ?? []).map((item, index) => (
                            <div key={`service-deliverable-${index}`} className="package-editor__chip">
                                <textarea
                                    className="package-editor__textarea"
                                    value={item}
                                    onChange={(event) => handleListChange("deliverables", index, event.target.value)}
                                    placeholder="Teslim kalemi"
                                />
                                <button type="button" className="package-editor__chip-button" onClick={() => removeListItem("deliverables", index)}>
                                    Sil
                                </button>
                            </div>
                        ))}
                        <button type="button" className="package-editor__chip-button" onClick={() => addListItem("deliverables")}>
                            Teslim maddesi ekle
                        </button>
                    </div>
                </fieldset>

                <fieldset className="package-editor__fieldset">
                    <legend>Proses</legend>
                    <div className="package-editor__chips">
                        {(draft.process ?? []).map((item, index) => (
                            <div key={`service-process-${index}`} className="package-editor__chip">
                                <input
                                    className="package-editor__input"
                                    value={item}
                                    onChange={(event) => handleListChange("process", index, event.target.value)}
                                    placeholder="Adım"
                                />
                                <button type="button" className="package-editor__chip-button" onClick={() => removeListItem("process", index)}>
                                    Sil
                                </button>
                            </div>
                        ))}
                        <button type="button" className="package-editor__chip-button" onClick={() => addListItem("process")}>
                            Adım ekle
                        </button>
                    </div>
                </fieldset>

                <fieldset className="package-editor__fieldset">
                    <legend>Araçlar</legend>
                    <div className="package-editor__chips">
                        {(draft.tools ?? []).map((item, index) => (
                            <div key={`service-tool-${index}`} className="package-editor__chip">
                                <input
                                    className="package-editor__input"
                                    value={item}
                                    onChange={(event) => handleListChange("tools", index, event.target.value)}
                                    placeholder="Kullanılan araç"
                                />
                                <button type="button" className="package-editor__chip-button" onClick={() => removeListItem("tools", index)}>
                                    Sil
                                </button>
                            </div>
                        ))}
                        <button type="button" className="package-editor__chip-button" onClick={() => addListItem("tools")}>
                            Araç ekle
                        </button>
                    </div>
                </fieldset>

                <fieldset className="package-editor__fieldset">
                    <legend>SSS</legend>
                    <div className="package-editor__chips">
                        {(draft.faq ?? []).map((item, index) => (
                            <div key={`service-faq-${index}`} className="package-editor__chip">
                                <input
                                    className="package-editor__input"
                                    value={item.question}
                                    onChange={(event) => handleFaqChange(index, "question", event.target.value)}
                                    placeholder="Soru"
                                />
                                <textarea
                                    className="package-editor__textarea"
                                    value={item.answer}
                                    onChange={(event) => handleFaqChange(index, "answer", event.target.value)}
                                    placeholder="Cevap"
                                />
                                <button type="button" className="package-editor__chip-button" onClick={() => removeFaq(index)}>
                                    Sil
                                </button>
                            </div>
                        ))}
                        <button type="button" className="package-editor__chip-button" onClick={addFaq}>
                            Soru ekle
                        </button>
                    </div>
                </fieldset>

                <fieldset className="package-editor__fieldset">
                    <legend>CTA</legend>
                    <label className="package-editor__label" htmlFor="service-cta-label">CTA etiketi</label>
                    <input
                        id="service-cta-label"
                        className="package-editor__input"
                        value={draft.ctaLabel}
                        onChange={(event) => handleFieldChange("ctaLabel", event.target.value)}
                        placeholder="Brief gönder"
                    />
                    <label className="package-editor__label" htmlFor="service-cta-url">CTA bağlantısı</label>
                    <input
                        id="service-cta-url"
                        className="package-editor__input"
                        value={draft.ctaUrl}
                        onChange={(event) => handleFieldChange("ctaUrl", event.target.value)}
                        placeholder="mailto:studio@modelerman.com"
                    />
                </fieldset>
            </div>

            <footer className="package-editor__actions">
                <div className="package-editor__left">
                    <button type="button" className="package-editor__button" onClick={onReset} disabled={saving || !hasChanges}>
                        Sıfırla
                    </button>
                    <button type="button" className="package-editor__button" onClick={onDuplicate} disabled={saving}>
                        Kopyala
                    </button>
                </div>
                <div className="package-editor__right">
                    <button type="button" className="package-editor__button" onClick={() => onDelete(draft.id)} disabled={saving}>
                        Sil
                    </button>
                    <button
                        type="button"
                        className="package-editor__button package-editor__button--primary"
                        onClick={onSave}
                        disabled={saving || !hasChanges}
                    >
                        {saving ? "Kaydediliyor..." : "Değişiklikleri kaydet"}
                    </button>
                </div>
            </footer>
        </aside>
    );
}
